import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { safify } from './utils/safify'
import { Image } from 'blaze-ui/icons/36'

const meta = {
  type: GenerationType.Image,
  icon: Image,
  steps: ['Generate Concepts'],
  title: 'Image',
  submitLabel: 'Insert',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1717684259/Home%20Card%20Previews/ybafhsrwsgqlcekuv7so.png',
}

const fields = {
  topic: topic.meta({ label: 'Describe the scene of your image', generationType: meta.type }),
  image_type: string()
    .required()
    .meta({ label: 'Type' })
    .oneOf(['illustration', 'photo'])
    .default('illustration')
    .transform(safify),
  image_aspect_ratio: string()
    .required()
    .oneOf(['square', 'landscape', 'portrait'])
    .default('square')
    .meta({ label: 'Aspect ratio' })
    .transform(safify),
  image_style: string()
    .meta({ label: 'Style' })
    .default('Illustrative')
    .oneOf([
      'Illustrative',
      'Realistic',
      'Photographic',
      'Ink',
      'Comic',
      'Abstract',
      'Minimalist',
      'Surreal',
      'Cartoon',
    ])
    .transform(safify),
  image_mood: string()
    .meta({ label: 'Mood' })
    .default('Happy')
    .oneOf(['Happy', 'Sad', 'Angry', 'Surprised', 'Scared', 'Excited', 'Calm', 'Confused'])
    .transform(safify),
}

export const ImageSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>
